import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import BankAccountsContext from "./BankAccountsContext";

const useBankAccountsContext = () => useDefinedContext(BankAccountsContext, "BankAccountsContext");

export default useBankAccountsContext;
